import { render, staticRenderFns } from "./ResourceSidebar.vue?vue&type=template&id=0b4a5881"
import script from "./ResourceSidebar.vue?vue&type=script&lang=js"
export * from "./ResourceSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports